// src/v2/pulse/PaneInfoTooltip.jsx
//
// Shared ⓘ info-icon tooltip used by all v2 Pulse panes.
// Canonical style: width:260, maxWidth:260, whiteSpace:"normal", and the
// shared tooltip body typography.
// — matches the SectionHeader tooltip in PulsePage.jsx.

import { useId } from "react";
import { useHoverIntent } from "../../components/useHoverIntent.js";
import { Info } from "lucide-react";
import { T } from "../../app/tokens.js";

export function PaneInfoTooltip({ text, label = "Information", testId, interactive = false }) {
  const { open: show, triggerProps } = useHoverIntent();
  const tooltipId = useId();
  return (
    <span
      data-testid={testId}
      style={{ position: "relative", display: "inline-flex", alignItems: "center" }}
      {...triggerProps}
    >
      {interactive ? (
        <button
          type="button"
          aria-label={label}
          aria-describedby={show ? tooltipId : undefined}
          style={{ display: "inline-flex", padding: 0, border: 0, background: "transparent", color: "inherit", cursor: "help" }}
        >
          <Info size={14} aria-hidden="true" style={{ color: "var(--v2-mid)" }} />
        </button>
      ) : (
        <Info size={14} style={{ color: "var(--v2-mid)", cursor: "help" }} />
      )}
      {show && (
        <span style={{
          position: "absolute", top: "calc(100% + 6px)", left: "50%", transform: "translateX(-50%)",
          background: "var(--v2-tooltip-bg)", color: "var(--v2-tooltip-fg)",
           fontSize: T.tooltip.fontSize, fontWeight: T.tooltip.fontWeight, padding: "7px 11px",
           borderRadius: 6, whiteSpace: "normal", width: 260, maxWidth: 260, lineHeight: T.tooltip.lineHeight, zIndex: 20,
          pointerEvents: "none",
        }} id={tooltipId} role="tooltip">
          {text}
        </span>
      )}
    </span>
  );
}
